module.exports = __webpack_public_path__ + "media/images/app/homepage/diamonds-mobile-f7adeb17f1c6db20d49e49693a6eee44.webp";